import {
  GraphFavoriteResponse,
  SummaryResponse,
  ViewFavoriteResponse,
  AddProjectToFavoriteResponse,
  GetFavortiesProjectResponse,
  ApiEnveloppe,
  UpdateFavoriteViewsV25Response,
  UpdateFavoriteGraphsV25Response,
  BasicFavoriteResponse,
} from '../../types/types';
import {
  _deleteArgosV25,
  _getArgosV25,
  _post,
  _postArgosV25,
  requestType,
} from './_internal';

export const addProjectToFavorite = (payload: {
  project_id: string;
}): Promise<AddProjectToFavoriteResponse> => {
  return _post({
    request_type: requestType.rajouter_un_projet_en_favori,
    project_id: payload.project_id,
  });
};

export const removeProjectfromFavorite = (payload: {
  project_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_projet_des_favoris,
    project_id: payload.project_id,
  });
};

export const getFavortiesProject = (): Promise<GetFavortiesProjectResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_projets_des_favoris,
  });
};

export const getFavoriteViewsV25 = (payload: {
  userId: number;
}): Promise<ViewFavoriteResponse> => {
  const route = `api/favorites/${payload.userId}/views`;
  return _getArgosV25({ route: route });
};

export const updateFavoriteViewsV25 = (payload: {
  userId: number;
  viewId: number;
}): Promise<UpdateFavoriteViewsV25Response> => {
  const route = `api/favorites/${payload.userId}/views/${payload.viewId}`;
  return _postArgosV25({ route: route });
};

export const removeFavoriteViewsV25 = (payload: {
  userId: number;
  viewId: number;
}): Promise<BasicFavoriteResponse> => {
  const route = `api/favorites/${payload.userId}/views/${payload.viewId}`;
  return _deleteArgosV25({ route: route });
};

export const getFavoriteDashboardsV25 = (payload: {
  userId: number;
}): Promise<ViewFavoriteResponse> => {
  const route = `api/favorites/${payload.userId}/views`;
  return _getArgosV25({ route: route });
};

export const getFavoriteGraphsV25 = (payload: {
  userId: number;
}): Promise<GraphFavoriteResponse> => {
  const route = `api/favorites/${payload.userId}/graphs`;
  return _getArgosV25({ route: route });
};

export const updateFavoriteGraphsV25 = (payload: {
  userId: number;
  graphId: number;
}): Promise<UpdateFavoriteGraphsV25Response> => {
  const route = `api/favorites/${payload.userId}/graphs/${payload.graphId}`;
  return _postArgosV25({ route: route });
};

export const removeFavoriteGraphsV25 = (payload: {
  userId: number;
  graphId: number;
}): Promise<BasicFavoriteResponse> => {
  const route = `api/favorites/${payload.userId}/graphs/${payload.graphId}`;
  return _deleteArgosV25({ route: route });
};

export const getHomeSummaryV25 = (payload: {
  userId: number;
}): Promise<SummaryResponse> => {
  return _getArgosV25({ route: `api/home/summary/${payload.userId}` });
};
